import useFeature from "hooks/useFeature";
const IfFeatureEnabled = ({ name, fallback = null, children }) => {
  const hasFeature = useFeature(name);
  if (hasFeature) {
    return children;
  }
  return fallback;
};
export default IfFeatureEnabled;
